<div class="row d-print-none" >
    <div class="col">
        <span class="h3">{{location}}</span>
    </div>
</div>
<hr class="d-print-none" >

<router-outlet (activate)="componentAdded($event)"></router-outlet>

